import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { EventImpl } from '@fullcalendar/core/internal';
import { Dispatch } from '@ngxs-labs/dispatch-decorator';
import { Actions, ofActionDispatched, Select, Store } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { BreakDetailsAndOcc } from '../../models/break.model';
import {
  DeleteBreakRequest,
  DeleteBreakSuccess,
  DeleteSelectedBreaksRequest,
  DeleteSelectedBreaksSuccess,
} from '../../states/break.actions';
import { BreakState } from '../../states/break.state';

@Component({
  selector: 'rk-break-deletion',
  templateUrl: './break-deletion.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BreakDeletionComponent implements OnInit, OnDestroy {
  @Select(BreakState.isDeletingBreak)
  isDeleting$: Observable<boolean>;

  deleteAll = false;

  get breakRepeat(): boolean {
    return (
      this.data &&
      (this.data.break.repeat.repeatDays.length > 0 || !!this.data.break.dailyRepeat)
    );
  }

  @Select(BreakState.selectedBreaksCount)
  selectedBreaks$: Observable<EventImpl[]>;

  subscription = new Subscription();

  constructor(
    private readonly store: Store,
    private readonly actions$: Actions,
    private readonly dialogRef: MatDialogRef<BreakDeletionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: BreakDetailsAndOcc,
  ) {}

  ngOnInit(): void {
    // Deletion succeed: close this dialog
    this.subscription.add(
      this.actions$
        .pipe(ofActionDispatched(DeleteBreakSuccess, DeleteSelectedBreaksSuccess))
        .subscribe(() => {
          this.closeSelf();
        }),
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  /**
   * Deletion submitted
   */
  onSubmit(multi = false): void {
    if (multi) {
      this.deleteSelected();
      return;
    }
    this.store.dispatch(
      new DeleteBreakRequest(this.deleteAll, this.data.break.id, this.data.occurrence),
    );
  }

  @Dispatch()
  deleteSelected = () => new DeleteSelectedBreaksRequest();

  /**
   * Close self (closing dialog)
   */
  closeSelf(): void {
    this.dialogRef.close();
  }
}
